<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars" />
    </button>

    <div class="navbar-logo">
      <h2 class="logo-text">L⚡t-ning</h2>
    </div>
    <div class="navigation-box d-flex justify-content-center">

    </div>

    <div class="user-settings">
      <a class="burger float-start mx-3" v-if="showLoyalty" @click="checkLoyalty">
        <font-awesome-icon icon="heart-circle-check" v-if="!!$store.getters.getLoyaltyDetails.barcode"/>
        <font-awesome-icon icon="heart-circle-plus" v-else/>
      </a>
      <Notification/>
      <OrdersBell/>
      <router-link to="/help" class="burger" v-b-tooltip="'User Manual'" style="text-decoration:none;">
        <font-awesome-icon icon="fa-solid fa-circle-question"/>
      </router-link>
      <button @click="toggleTheme" class="theme-toggle-button">
        <font-awesome-icon :icon="currentTheme === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon'" />
        <span class="ml-2">{{ currentTheme === 'dark' ? 'Light Mode' : 'Dark Mode' }}</span>
      </button>
    </div>

    <div class="right-section">
      <button @click="syncData" class="refresh-btn">
        <font-awesome-icon icon="arrows-rotate"/>
      </button>
      <div class="device-mode">
        <font-awesome-icon v-if="isAndroid" :icon="['fas', 'mobile-screen']" class="device-icon" />
        <font-awesome-icon v-else :icon="['fas', 'desktop']" class="device-icon" />
        <span class="mode-text">{{ isAndroid ? 'Mobile' : 'Desktop' }} Mode</span>
      </div>
    </div>

    <custom-modal title="Add Loyalty Customer To Sale" ref="scanLoyalty" @open="focusInput">
      <div v-if="!loyaltyDetails.barcode">
        <label for="loyalty-barcode">Scan Barcode</label>
        <input type="text" class="form-control" :disabled="$store.getters.getLoadingState" id="loyalty-barcode"
               v-model="loyaltyBarcode" ref="loyaltyCode"
               @keyup.enter="validateBarcode">
      </div>
      <div class="d-flex flex-column" v-else>
        <span class="text-sm text-secondary">Barcode : {{ loyaltyDetails.barcode }}</span>
        <div class="d-flex flex-row">
          Customer : {{ loyaltyDetails.name }} {{ loyaltyDetails.surname }}
          <a class="btn btn-sm btn-outline-primary mx-2" @click="$store.commit(`setLoyaltyDetails`,{})">
            <font-awesome-icon icon="close"/>
          </a>
        </div>
        <span>Contact : {{ loyaltyDetails.contact }}</span>
        Points Value : {{ loyaltyDetails.balance }} points - ({{ $utils.formatMoney(loyaltyDetails.pointsInCash) }})
      </div>
    </custom-modal>
  </div>
</template>

<script>
import Notification from "@/components/layout/navigation/Notification";
import OrdersBell from "@/components/layout/navigation/OrdersBell.vue";
import CustomModal from "@/components/layout/utils/CustomModal";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "NavigationBar",
  components: { CustomModal, Notification, OrdersBell },
  computed: {
    ...mapGetters(['getCurrentTheme']),
    currentTheme() {
      return this.getCurrentTheme;
    },
    salesScreens() {
      return [`pos`, `payment`, `split-payment`, `instruction`];
    },
    showLoyalty() {
      let isSalesScreen = this.salesScreens.includes(this.$route.name);
      return this.$store.getters.getHasLoyalty && isSalesScreen;
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },
    // Check if the device is Android
    isAndroid() {
      const isAndroidDevice = navigator.userAgent.toLowerCase().includes('android');
      return isAndroidDevice;
    },
  },
  data() {
    return {
      loyaltyBarcode: null,

    };
  },
  mounted() {
    // Dispatch action to initialize theme from localStorage or system preference
    this.initializeTheme();
  },
  props: {
    toggle: {
      type: Function,
      required: true,
    },
  },
  methods: {
    ...mapActions(['toggleTheme', 'initializeTheme']),
    syncData() {
      return window.location.reload(true);
    },
    tawkTo() {
      return window.open('https://tawk.to/LytSupport', '_self');
    },
    validateBarcode() {
      if (!isValidString(this.loyaltyBarcode)) return;
      this.$refs.scanLoyalty.closeModal();
      this.$utils.showLoading();
      return this.$store
          .dispatch(`checkLoyaltyBarcode`, this.loyaltyBarcode)
          .finally(() => {
            this.loyaltyBarcode = null;
            this.$refs.scanLoyalty.openModal();
          });
    },
    checkLoyalty() {
      return this.$refs.scanLoyalty.openModal();
    },
    async focusInput() {
      if (!!this.loyaltyDetails.barcode) return;
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return this.$refs.loyaltyCode.focus();
    },
    // toggleTheme() { // Removed, now managed by Vuex
    //   // Add transition class to body for smooth theme change
    //   document.body.classList.add('theme-transition');

    //   // Set a timeout to remove the transition class after the transition is complete
    //   setTimeout(() => {
    //     document.body.classList.remove('theme-transition');
    //   }, 1000);

    //   // Toggle the theme
    //   this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light'; // Update the component's data property
    //   document.documentElement.setAttribute('data-theme', this.currentTheme);
    //   localStorage.setItem('theme', this.currentTheme);

    //   // Show a subtle notification
    //   this.$utils.showToast(`Switched to ${this.currentTheme} mode`, 'success');
    // }
  },
};
</script>

<style lang="scss" scoped>
.container-fluid.navigation-bar {
  background: var(--bg-gradient);
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: var(--card-shadow);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0) 100%
    );
    transform: rotate(30deg);
    animation: shine 8s infinite;
  }

  .burger {
    width: 40px;
    height: 40px;
    background: rgba(var(--accent-primary), 0.15);
    color: var(--text-primary);
    font-size: 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: var(--transition-speed);
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      background: rgba(var(--accent-primary), 0.25);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .navbar-logo {
    flex: 1;
    margin: 0 1rem;

    .logo-text {
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      font-size: 28px;
      background: linear-gradient(to right, var(--accent-electric-blue), var(--accent-neon-purple));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
  }

  // Mobile Responsive Styles
  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;

    .burger {
      width: 36px;
      height: 36px;
      font-size: 18px;
    }

    .navbar-logo {
      margin: 0 0.5rem;

      .logo-text {
        font-size: 20px;
      }
    }

    .user-settings {
      gap: 0.5rem;

      .theme-toggle-button {
        padding: 6px 12px;
        font-size: 12px;

        svg {
          font-size: 14px;
        }

        span {
          display: none; // Hide text on mobile to save space
        }
      }
    }

    .right-section {
      gap: 8px;
      padding-left: 12px;

      .device-mode {
        padding: 4px 10px;

        .device-icon {
          font-size: 16px;
        }

        .mode-text {
          font-size: 0.75rem;
        }
      }

      .refresh-btn {
        width: 36px;
        height: 36px;
        font-size: 18px;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 0.4rem 0.5rem;

    .burger {
      width: 32px;
      height: 32px;
      font-size: 16px;
    }

    .navbar-logo {
      margin: 0 0.25rem;

      .logo-text {
        font-size: 18px;
      }
    }

    .user-settings {
      gap: 0.25rem;

      .theme-toggle-button {
        padding: 6px 10px;
        border-radius: 16px;
      }
    }

    .right-section {
      gap: 6px;
      padding-left: 10px;

      .device-mode {
        padding: 4px 8px;

        .mode-text {
          display: none; // Hide text on very small screens
        }
      }

      .refresh-btn {
        width: 32px;
        height: 32px;
        font-size: 16px;
      }
    }
  }

  .navigation-box {
    display: flex;
    align-items: center;
    gap: 1rem;

    img {
      transition: var(--transition-speed);
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
    padding-left: 16px;
    border-left: 1px solid var(--card-border);
  }

  .device-mode {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    background: rgba(var(--accent-electric-blue), 0.08);
    border-radius: 20px;
    pointer-events: none;

    .device-icon {
      font-size: 18px;
      color: var(--text-primary);
    }

    .mode-text {
      color: var(--text-primary);
      font-size: 0.875rem;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }

  .refresh-btn {
    width: 40px;
    height: 40px;
    background: rgba(var(--accent-primary), 0.15);
    color: var(--text-primary);
    font-size: 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: var(--transition-speed);
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.2) 50%,
              rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(30deg);
      animation: shine 4s infinite;
    }

    &:hover {
      background: rgba(var(--accent-primary), 0.25);
      transform: translateY(-2px) rotate(180deg);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(0) rotate(180deg);
    }

    .icon {
      transition: transform 0.3s ease;
    }
  }

  .user-settings {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .burger {
      position: relative;
      color: var(--text-primary);

      &:hover {
        transform: translateY(-2px);
      }

      &.active {
        background: rgba(var(--accent-primary), 0.25);
      }
    }

    .theme-toggle-button {
      background: var(--secondary-button-bg);
      color: var(--secondary-button-text);
      border: 1px solid var(--card-border);
      border-radius: 20px;
      padding: 8px 16px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      transition: var(--transition-speed);
      box-shadow: var(--card-shadow);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to right,
            var(--accent-electric-blue) 0%,
            var(--accent-neon-purple) 100%);
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 0;
      }

      svg, span {
        position: relative;
        z-index: 1;
      }

      svg {
        font-size: 16px;
        transition: transform 0.5s ease;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: var(--card-shadow-hover);
        color: white;

        &::before {
          opacity: 1;
        }

        svg {
          transform: rotate(30deg) scale(1.2);
        }
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%) rotate(30deg);
  }
  15%, 100% {
    transform: translateX(100%) rotate(30deg);
  }
}

// Update the modal styles
:deep(.modal-content) {
  border-radius: 16px;
  border: none;
  box-shadow: var(--card-shadow);
  background: var(--card-bg);
  color: var(--text-primary);
}

:deep(.form-control) {
  border-radius: 10px;
  border: 1px solid var(--card-border);
  padding: 0.75rem;
  transition: var(--transition-speed);
  background: var(--card-bg);
  color: var(--text-primary);

  &:focus {
    border-color: var(--accent-primary);
    box-shadow: 0 0 0 3px rgba(51, 156, 255, 0.1);
  }
}

:deep(.btn-outline-primary) {
  border-radius: 10px;
  padding: 0.5rem 1rem;
  transition: var(--transition-speed);
  border-color: var(--accent-primary);
  color: var(--accent-primary);

  &:hover {
    transform: translateY(-2px);
    background: var(--accent-primary);
    color: white;
    box-shadow: 0 4px 12px rgba(0, 146, 247, 0.2);
  }
}

.text-sm {
  font-size: 0.875rem;
  color: var(--text-secondary);
}
</style>
